<template>
    <v-img :src="imageSrc"
           min-width="50"
           width="80"
           :max-height="height"
           lazy-src="/images/default.jpg"
           :alt="altText"
           contain></v-img>
</template>

<script>
    window.Handbook = window.Handbook || {}
    const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
    export default {
        props: {
            id: {
                type: Number,
                required: false,
                value: '0'
            },
            height: {
                default: '355'
            },
            placeholder: {
                default: false
            }
        },
        computed: {
            imageSrc: function () {
                if (!this.placeholder && this.id && (this.id != undefined || this.id != 'Undefined')) {
                    return `${apiUri}/api/HistoricalInformation/Portrait?id=${this.id}`;
                }
                else
                    return '/images/default.jpg';
            },
            altText: function () {
                return 'parliamentary office holder';
            }
        }
    }
</script>
